var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NavigationService } from '../services/navigation/navigation.service';
import { TvShopEntertainmentPack } from '../model/tv-shop-entertainment-pack';
import { LabelkeyService } from '../services/labelkey/labelkey.service';
import { SelectableNavigationItem } from '../model/selectable-navigation-item';
import { Order } from '../model/order';
import { OmapiIdConstants } from '../shared/omapi-id-constants';
import { EmitterConstants } from '../shared/emitter-constants';
import { Emitter } from '../shared/utils/emitter/emitter';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { TvShopStateService } from '../services/state/tv-shop-state.service';
var OrderButtonComponent = /** @class */ (function (_super) {
    __extends(OrderButtonComponent, _super);
    function OrderButtonComponent(navigationService, labelkeyService, stateService, analyticsService, cd) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.labelkeyService = labelkeyService;
        _this.stateService = stateService;
        _this.analyticsService = analyticsService;
        _this.cd = cd;
        _this.isOrderable = true;
        _this.isGroupPack = false;
        _this.emitOnEnterPressed = new EventEmitter();
        _this.emitOnBack = new EventEmitter();
        _this.downGradePackIsTrial = false;
        Emitter.of(EmitterConstants.DOWNGRADE_PACK_IS_TRIAL).subscribe(function (value) {
            if (value) {
                _this.downGradePackIsTrial = value;
            }
        });
        return _this;
    }
    OrderButtonComponent.prototype.onEnter = function () {
        var order;
        if (((this.isDeepLinking) && !this.isOrderable || this.orderButtonAvailable) && this.isPackOrderable() ||
            this.isTrial ||
            this.isGroupPack) {
            order = this.createOrder();
            this.emitOnEnterPressed.emit(order);
            if (order.type !== Order.TRIALS) {
                this.analyticsService.onReadyToOrder(order);
            }
        }
    };
    OrderButtonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.stateService.isOrderProcessPending$.subscribe(function (orderProcessPending) {
            _this.orderButtonAvailable = !orderProcessPending || !_this.isOrderable;
            _this.determineButtonText();
        });
        this.registerOnNavigationService();
    };
    OrderButtonComponent.prototype.registerOnNavigationService = function () {
        this.navigationService.registerNavigation(this, this.ownerComponent);
    };
    OrderButtonComponent.prototype.ngOnChanges = function (changes) {
        this.determineButtonText();
    };
    Object.defineProperty(OrderButtonComponent.prototype, "activeGroupVariant", {
        get: function () {
            return this.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "activeClass", {
        get: function () {
            return this.active && (!this.subPack && !this.isPackSubscribed || this.subPack && !this.isSubPackSubscribed);
        },
        enumerable: true,
        configurable: true
    });
    OrderButtonComponent.prototype.activate = function (active) {
        this.active = active;
        this.cd.detectChanges();
    };
    OrderButtonComponent.prototype.determineButtonText = function () {
        if (this.buttonTextKey !== undefined) {
            return;
        }
        if (this.subPack === undefined) {
            this.buttonTextKey = this.getButtonTextForPack(this.pack);
        }
        else {
            if (!this.pack.subscribed && !this.subPack.subscribed) {
                this.buttonTextKey = this.labelkeyService.getOrderButtonLabelKeyWithSubProduct(this.pack.omapiId, this.subPack.omapiId);
            }
            else {
                this.buttonTextKey = this.getButtonTextForPack(this.subPack);
            }
        }
    };
    OrderButtonComponent.prototype.getButtonTextForPack = function (pack) {
        if (pack.subscribed) {
            return this.labelkeyService.getSubscribedLabelKey(pack.omapiId, this.isDeepLinking);
        }
        if (this.shouldShowUpgrade(pack)) {
            return this.labelkeyService.getLabelForUpgrade();
        }
        return this.labelkeyService.getOrderButtonLabelKey(pack.omapiId);
    };
    OrderButtonComponent.prototype.shouldShowUpgrade = function (pack) {
        return pack && pack.isUpgrade && this.isOrderable;
    };
    OrderButtonComponent.prototype.isPackOrderable = function () {
        if (this.pack && this.subPack) {
            if (this.pack.subscribed) {
                return this.subPack.isOrderable();
            }
            else {
                return this.pack.isOrderable() && this.subPack.isOrderable();
            }
        }
        else if (this.pack) {
            return this.pack.isOrderable();
        }
        return false;
    };
    OrderButtonComponent.prototype.createOrder = function () {
        var omapiId = this.isTrial ? OmapiIdConstants.TRIALS : this.pack.omapiId;
        var subOmapiId = this.subPack ? this.subPack.omapiId : undefined;
        var packPrice = this.pack && this.pack.priceDetail && this.pack.priceDetail.promoPrice ?
            this.pack.priceDetail.promoPrice.value : undefined;
        var subPackPrice = this.subPack && this.subPack.priceDetail && this.subPack.priceDetail.promoPrice ?
            this.subPack.priceDetail.promoPrice.value : undefined;
        var orderType = this.isDayPass ? Order.DAYPASS : this.isTrial ? Order.TRIALS : Order.ORDER;
        var order = new Order(omapiId, packPrice, subOmapiId, subPackPrice, orderType);
        if (this.pack && !this.pack.isOrderable() && this.subPack && this.subPack.isOrderable()) {
            this.transformSubpackToPack(order);
        }
        return order;
    };
    Object.defineProperty(OrderButtonComponent.prototype, "isPackSubscribed", {
        get: function () {
            return this.pack && this.pack.subscribed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "isDowngrade", {
        get: function () {
            return this.pack && this.pack.isDowngrade;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "isSubPackSubscribed", {
        get: function () {
            return this.subPack && this.subPack.subscribed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "isPlayMoreAndUpgradeFromTrial", {
        get: function () {
            return this.pack && (this.pack.omapiId === OmapiIdConstants.PLAY_MORE) && this.downGradePackIsTrial;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "isPlay", {
        get: function () {
            return this.pack && this.pack.omapiId === OmapiIdConstants.STREAMZ || this.pack && this.pack.omapiId === OmapiIdConstants.RED_CARPET_MORE;
        },
        enumerable: true,
        configurable: true
    });
    OrderButtonComponent.prototype.packName = function () {
        if (this.pack && this.pack.omapiId) {
            if (this.pack.omapiId === OmapiIdConstants.RED_CARPET_MORE) {
                return OmapiIdConstants.COM_NAME_RED_CARPET_MORE;
            }
            return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.pack.omapiId);
        }
        return '';
    };
    OrderButtonComponent.prototype.superiorSubscribedPackName = function () {
        if (this.superiorSubscribedPack) {
            return this.superiorSubscribedPack.omapiId === OmapiIdConstants.RED_CARPET_MORE ?
                OmapiIdConstants.COM_NAME_RED_CARPET_MORE : OmapiIdConstants.PRODUCT_NAME_MAP.get(this.superiorSubscribedPack.omapiId);
        }
        return '';
    };
    Object.defineProperty(OrderButtonComponent.prototype, "showOrderButton", {
        get: function () {
            return (this.orderButtonAvailable || this.isPackSubscribed) && !this.isDowngrade;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "showPendingOrderInfo", {
        get: function () {
            return !this.orderButtonAvailable && !this.isPackSubscribed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderButtonComponent.prototype, "showDowngradeMessage", {
        get: function () {
            return this.orderButtonAvailable && this.isDowngrade;
        },
        enumerable: true,
        configurable: true
    });
    OrderButtonComponent.prototype.onBack = function () {
        this.emitOnBack.emit({
            value: true
        });
    };
    OrderButtonComponent.prototype.isSubscribed = function () {
        return this.isSubscribedToPackOrSubPack;
    };
    Object.defineProperty(OrderButtonComponent.prototype, "isSubscribedToPackOrSubPack", {
        get: function () {
            return (this.isPackSubscribed && !this.subPack) || (this.isPackSubscribed && this.isSubPackSubscribed);
        },
        enumerable: true,
        configurable: true
    });
    OrderButtonComponent.prototype.canNavigateToDirection = function (keyCode) {
        return this.isDeepLinking && this.pack && !this.pack.subscribed || !this.isDeepLinking;
    };
    OrderButtonComponent.prototype.transformSubpackToPack = function (event) {
        event.packOmapiId = event.subPackOmapiId;
        event.packPrice = event.subPackPrice;
        event.subPackOmapiId = undefined;
        event.subPackPrice = undefined;
    };
    return OrderButtonComponent;
}(SelectableNavigationItem));
export { OrderButtonComponent };
